import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import authService from "../../services/authService";
import QuillRichText from "../../components/QuillRichText";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "../../utils/cropUtils";

import api from "../../config/axiosConfig";
import { Mic, MicOff } from "lucide-react";
import "quill/dist/quill.snow.css";

import "./DetailExam.css";

const DetailExam = () => {
  const navigate = useNavigate();
  const {publicId} = useParams();

  // EXAMEN + historiques (gauche)
  const [examen, setExamen] = useState(null);
  const [examens, setExamens] = useState([]);
 const [ordonnances, setOrdonnances] = useState([]);
const [ordonnanceFile, setOrdonnanceFile] = useState(null);
const [showCropper, setShowCropper] = useState(false);
const [crop, setCrop] = useState({ x: 0, y: 0 });
const [zoom, setZoom] = useState(1);
const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
 const [selectedImage, setSelectedImage] = useState(null);
 const [selectedImageIndex, setSelectedImageIndex] = useState(null);
 const [selectedOrdonnanceIndex, setSelectedOrdonnanceIndex] = useState(null);

const [rotation, setRotation] = useState(0);
 
const [imagesExamen, setImagesExamen] = useState([]);




  // RAPPORTS (droite)
  const [rapports, setRapports] = useState([]);
  const [loadingRapports, setLoadingRapports] = useState(false);

  // Popup ajout/édition rapport
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [editingRapportId, setEditingRapportId] = useState(null); // null = ajout, id = édition
  const [titre, setTitre] = useState("");
  const [indication, setIndication] = useState("");
  const [resultat, setResultat] = useState("");
  const [conclusion, setConclusion] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  // Popup “Utiliser un rapport type”
  const [showRTModal, setShowRTModal] = useState(false);
  const [examensType, setExamensType] = useState([]);
  const [rtSearch, setRtSearch] = useState("");

  // Popup info
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  // Sauvegarde rapide d'un RapportType
  const [savingRT, setSavingRT] = useState(false);

  // -------- Speech-to-Text state
  const [sttOpen, setSttOpen] = useState(false);
  const [sttError, setSttError] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [activeField, setActiveField] = useState(null); // 'titre' | 'indication' | 'resultat' | 'conclusion'
  const [liveText, setLiveText] = useState(""); // texte affiché en live (final + interim)
  const recognitionRef = useRef(null);
  const finalTextRef = useRef(""); // accumulateur de résultats finaux
  const interimRef = useRef("");   // dernier interim

  // Helpers headers (token + tenant)
  const buildHeaders = () => {
    const token = localStorage.getItem("token");
    const tenantId = localStorage.getItem("tenant");
    return {
      Authorization: `Bearer ${token}`,
      ...(tenantId ? { "X-Tenant-Id": String(tenantId) } : {}),
    };
  };

  const htmlToPlainText = (html = "") => {
  if (!html) return "";
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  tmp.querySelectorAll("p, li, br, div").forEach((el) => {
    if (el.tagName === "BR") el.replaceWith("\n");
    else if (el.tagName === "LI") el.insertAdjacentText("afterend", "\n");
    else if (el.tagName === "P" || el.tagName === "DIV") el.insertAdjacentText("beforeend", "\n");
  });
  return (tmp.textContent || tmp.innerText || "").replace(/\r?\n\s*\n/g, "\n").trim();
};

const handleDeleteRapport = async (rapportId) => {
  if (!window.confirm("Voulez-vous vraiment supprimer ce rapport ?")) return;

  try {
    await api.delete(
      `${process.env.REACT_APP_EUREKA_PACS_URL}/api/rapports/${rapportId}`,
      { headers: buildHeaders() }
    );

    // ✅ Mettre à jour la liste locale
    setRapports((prev) => prev.filter((r) => r.id !== rapportId));

    setPopupMessage("Le rapport a été supprimé avec succès.");
    setShowPopup(true);
  } catch (error) {
    console.error("Erreur suppression rapport :", error);
    setPopupMessage("Erreur lors de la suppression du rapport.");
    setShowPopup(true);
  }
};

const handleUploadImageExamen = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const formData = new FormData();
  formData.append("file", file);

  try {
    const { data } = await api.post(
      `${process.env.REACT_APP_EUREKA_PACS_URL}/api/examen/${publicId}/upload?categorie=imageExamen`,
      formData,
      { headers: { ...buildHeaders(), "Content-Type": "multipart/form-data" } }
    );

    // rafraîchir la liste des images
    fetchImagesExamen();

    setPopupMessage("✅ Image ajoutée avec succès.");
    setShowPopup(true);
  } catch (error) {
    console.error("Erreur upload image :", error);
    setPopupMessage("❌ Erreur lors de l’ajout de l’image.");
    setShowPopup(true);
  }
};


const handleUploadOrdonnance = async (e) => {
  const file = e.target.files[0];
  if (!file) return;
  setOrdonnanceFile(file);  // ✅ ça fonctionne maintenant

  const formData = new FormData();
  formData.append("file", file);

  try {
    const { data } = await api.post(
      `${process.env.REACT_APP_EUREKA_PACS_URL}/api/examen/${publicId}/upload?categorie=ordonnance`,
      formData,
      { headers: { ...buildHeaders(), "Content-Type": "multipart/form-data" } }
    );

    fetchOrdonnances(); // ✅ recharge la liste
    setPopupMessage("✅ bulletin de l'examen ajouté avec succès.");
    setShowPopup(true);
  } catch (error) {
    console.error("Erreur upload ordonnance :", error);
    setPopupMessage("❌ Erreur lors de l’ajout de l’ordonnance.");
    setShowPopup(true);
  }
};




const fetchImagesExamen = async () => {
  try {
    const { data } = await api.get(
      `${process.env.REACT_APP_EUREKA_PACS_URL}/api/examen/${publicId}/images`,
      { headers: buildHeaders() }
    );

    const withSignedUrls = await Promise.all(
      data.map(async (img) => {
        try {
          const res = await api.get(
            `${process.env.REACT_APP_EUREKA_PACS_URL}/api/fichiers/images/${img.nom}/url`,
            { headers: buildHeaders() }
          );
          return { ...img, presignedUrl: res.data };
        } catch (err) {
          console.error("Erreur URL signée image :", err);
          return img;
        }
      })
    );

    setImagesExamen(withSignedUrls || []);
  } catch (err) {
    console.error("Erreur récupération images examen :", err);
  }
};



  // --- GET /api/examen/{id}
  const fetchExamen = async () => {
    try {
      const { data } = await api.get(
        `${process.env.REACT_APP_EUREKA_PACS_URL}/api/examen/${publicId}`,
        { headers: buildHeaders() }
      );
      setExamen(data);
      if (Array.isArray(data.rapports)) setRapports(data.rapports);
    } catch (error) {
      console.error("Erreur lors de la récupération des détails :", error);
    }
  };

  // PUT examen (valider / sauvegarder)
  const handleSave = async (statut) => {
    try {
      const response = await api.put(
        `${process.env.REACT_APP_EUREKA_PACS_URL}/api/examen/${publicId}`,
        {
          indication,
          resultat,
          conclusion,
          titre,
          statut,
          idRadiologue: 1,
          filePath: [],
        },
        { headers: { ...buildHeaders(), "Content-Type": "application/json" } }
      );
      console.log("Examen mis à jour", response.data);
      setPopupMessage(
        statut === "TERMINE"
          ? "L'examen a été validé avec succès."
          : "L'examen a été sauvegardé avec succès."
      );
      setShowPopup(true);
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'examen :", error);
      setPopupMessage("Erreur lors de la mise à jour de l'examen.");
      setShowPopup(true);
    }
  };

  // GET /api/examen/{id}/rapports
  const fetchRapports = async () => {
    try {
      setLoadingRapports(true);
      const { data } = await api.get(
        `${process.env.REACT_APP_EUREKA_PACS_URL}/api/examen/${publicId}/rapports`,
        { headers: buildHeaders() }
      );
      if (Array.isArray(data)) setRapports(data);
    } catch {
      // ignore si endpoint non présent
    } finally {
      setLoadingRapports(false);
    }
  };

  // GET /api/rapportTypes/user/{username}
  const fetchExamensType = async () => {
    const username = localStorage.getItem("login");
    if (!username) return;
    try {
      const { data } = await api.get(
        `${process.env.REACT_APP_EUREKA_PACS_URL}/api/rapportTypes/user/${username}`,
        { headers: buildHeaders() }
      );
      setExamensType(data || []);
    } catch (error) {
      console.error("Erreur lors de la récupération des rapports types :", error);
    }
  };

  useEffect(() => {
    if (!publicId) return;
    fetchExamen().then(fetchRapports);
    fetchExamensType();
  }, [publicId]);

  useEffect(() => {
  if (examen?.ordonnances) {
    setOrdonnances(examen.ordonnances);
  }
}, [examen]);

useEffect(() => {
  const handleKey = (e) => {
    if (selectedImageIndex === null) return;
    if (e.key === "ArrowRight") {
      setSelectedImageIndex((i) => (i + 1) % imagesExamen.length);
    }
    if (e.key === "ArrowLeft") {
      setSelectedImageIndex((i) => (i - 1 + imagesExamen.length) % imagesExamen.length);
    }
    if (e.key === "Escape") {
      setSelectedImageIndex(null);
    }
  };
  window.addEventListener("keydown", handleKey);
  return () => window.removeEventListener("keydown", handleKey);
}, [selectedImageIndex, imagesExamen.length]);



  // GET /api/examen_patient/{patientId}
  useEffect(() => {
    const fetchExamens = async () => {
      try {
        const { data } = await api.get(
          `${process.env.REACT_APP_EUREKA_PACS_URL}/api/examen_patient/${examen?.patient?.id}`,
          { headers: buildHeaders() }
        );
        setExamens(data);
      } catch (error) {
        console.error("Erreur lors de la récupération des examens :", error);
      }
    };
    if (examen?.patient?.id) fetchExamens();
  }, [examen?.patient?.id]);

  const openOHIFViewer = (examId) => {
    const url = process.env.REACT_APP_VIEWER_URL  + `viewer/viewer/${examId}`;
    const windowFeatures = "width=800,height=600,resizable,scrollbars=yes";
    const newWindow = window.open(url, "_blank", windowFeatures);
    if (newWindow) newWindow.focus();
    else alert("La fenêtre pop-up a été bloquée par votre navigateur.");
  };

  // Utilitaires
  const calculerAge = (dateNaissanceStr) => {
    if (!dateNaissanceStr) return null;
    const naissance = new Date(dateNaissanceStr);
    const maintenant = new Date();
    let age = maintenant.getFullYear() - naissance.getFullYear();
    const m = maintenant.getMonth() - naissance.getMonth();
    if (m < 0 || (m === 0 && maintenant.getDate() < naissance.getDate())) age--;
    return age;
  };
  const fmtDate = (d) => {
    if (!d) return "";
    try { return new Date(d).toLocaleDateString(); } catch { return d; }
  };
  const preview = (s, n = 40) => (s ? (s.length > n ? s.slice(0, n) + "…" : s) : "");

  // Ouvrir popup en mode AJOUT
  const openAddPopup = () => {
    setEditingRapportId(null);
    setTitre("");
    setIndication("");
    setResultat("");
    setConclusion("");
    setShowAddPopup(true);
  };

  // Ouvrir popup en mode EDITION
  const openEditPopup = (r) => {
    setEditingRapportId(r.id);
    setTitre(r.titre || "");
    setIndication(r.indication || "");
    setResultat(r.resultat || "");
    setConclusion(r.conclusion || "");
    setShowAddPopup(true);
  };

const fetchOrdonnances = async () => {
  try {
    const { data } = await api.get(
      `${process.env.REACT_APP_EUREKA_PACS_URL}/api/examen/${publicId}/ordonnances`,
      { headers: buildHeaders() }
    );

    const withSignedUrls = await Promise.all(
      data.map(async (ord) => {
        try {
          const res = await api.get(
          `${process.env.REACT_APP_EUREKA_PACS_URL}/api/fichiers/ordonnances/${encodeURIComponent(ord.nom)}/url`,
          { headers: buildHeaders() }
        );

          return { ...ord, presignedUrl: res.data };
        } catch (err) {
          console.error("Erreur génération URL signée ordonnance :", err);
          return ord;
        }
      })
    );

    setOrdonnances(withSignedUrls || []);
  } catch (error) {
    console.error("Erreur lors de la récupération des ordonnances :", error);
  }
};


const handleDeleteFichier = async (fichierId, type) => {
  if (!window.confirm("Voulez-vous vraiment supprimer ce fichier ?")) return;

  try {
    await api.delete(
      `${process.env.REACT_APP_EUREKA_PACS_URL}/api/fichiers/${fichierId}`,
      { headers: buildHeaders() }
    );

    // Rafraîchir la liste selon le type
    if (type === "ordonnance") {
      fetchOrdonnances();
    } else if (type === "imageExamen") {
      fetchImagesExamen();
    }

    setPopupMessage("✅ Fichier supprimé avec succès.");
    setShowPopup(true);
  } catch (error) {
    console.error("Erreur suppression fichier :", error);
    setPopupMessage("❌ Erreur lors de la suppression du fichier.");
    setShowPopup(true);
  }
};

  // POST /api/examen/{id}/rapports/{login}  |  PUT /api/rapports/{rapportId}
  const handleSaveRapport = async () => {
    if (!titre && !indication && !resultat && !conclusion) {
      alert("Veuillez renseigner au moins un champ du rapport.");
      return;
    }
    try {
      setIsSaving(true);
      const login = localStorage.getItem("login");
      if (editingRapportId == null) {
          // Création d’un nouveau rapport
          const { data } = await api.post(
            `${process.env.REACT_APP_EUREKA_PACS_URL}/api/examen/${publicId}/rapports/${login}`,
            { titre, indication, resultat, conclusion, statut: "AVEC_CR" },
            { headers: { ...buildHeaders(), "Content-Type": "application/json" } }
          );

          // ✅ Mettre à jour les rapports localement
          setRapports((prev) => [...prev, data]);

          // ✅ Mettre à jour aussi le statut de l’examen
          await api.put(
            `${process.env.REACT_APP_EUREKA_PACS_URL}/api/examen/${publicId}`,
            { statut: "AVEC_CR" },
            { headers: { ...buildHeaders(), "Content-Type": "application/json" } }
          );

          // ✅ Recharger examen (pour que le statut change à l’écran)
          await fetchExamen();
        setPopupMessage("Le rapport a été créé avec succès.");
      } else {
        const { data } = await api.put(
          `${process.env.REACT_APP_EUREKA_PACS_URL}/api/rapports/${editingRapportId}`,
          { titre, indication, resultat, conclusion },
          { headers: { ...buildHeaders(), "Content-Type": "application/json" } }
        );
        setRapports((prev) => prev.map((r) => (r.id === editingRapportId ? data : r)));
        setPopupMessage("Le rapport a été mis à jour avec succès.");
      }

      setShowAddPopup(false);
      setEditingRapportId(null);
      setTitre("");
      setIndication("");
      setResultat("");
      setConclusion("");
      setShowPopup(true);
    } catch (err) {
      console.error("Erreur sauvegarde rapport :", err);
      setPopupMessage("Échec de la sauvegarde du rapport.");
      setShowPopup(true);
    } finally {
      setIsSaving(false);
    }
  };

  // 🔎 Fonction pour colorer les mots-clés trouvés
const highlightExcerpt = (text, terms, context = 30) => {
  if (!text) return "";

  // ✅ Si pas de recherche → afficher texte normal tronqué
  if (!terms || terms.length === 0) {
    return text.length > 80 ? text.slice(0, 80) + "…" : text;
  }

  const lower = text.toLowerCase();
  const matches = [];

  terms.forEach(term => {
    let idx = lower.indexOf(term.toLowerCase());
    while (idx !== -1) {
      matches.push([idx, idx + term.length]);
      idx = lower.indexOf(term.toLowerCase(), idx + term.length);
    }
  });

  // ❌ Avant : return "" → colonne vide
  // ✅ Maintenant : retourner le texte normal (tronqué) si pas de match
  if (matches.length === 0) {
    return text.length > 80 ? text.slice(0, 80) + "…" : text;
  }

  // Fusionner les zones proches
  matches.sort((a, b) => a[0] - b[0]);
  const merged = [];
  let [start, end] = matches[0];
  for (let i = 1; i < matches.length; i++) {
    if (matches[i][0] <= end + context) {
      end = Math.max(end, matches[i][1]);
    } else {
      merged.push([start, end]);
      [start, end] = matches[i];
    }
  }
  merged.push([start, end]);

  // Construire l'extrait
  const parts = merged.map(([s, e]) => {
    const excerptStart = Math.max(0, s - context);
    const excerptEnd = Math.min(text.length, e + context);
    let excerpt = text.slice(excerptStart, excerptEnd);

    // Surligner les mots-clés
    terms.forEach(term => {
      const regex = new RegExp(`(${term})`, "gi");
      excerpt = excerpt.replace(regex, `<mark class="highlight">$1</mark>`);
    });

    if (excerptStart > 0) excerpt = "…" + excerpt;
    if (excerptEnd < text.length) excerpt += "…";
    return excerpt;
  });

  return <span dangerouslySetInnerHTML={{ __html: parts.join(" … ") }} />;
};



  // ➕ AJOUTER AUX RAPPORTS TYPES
  const handleAddToRapportTypes = async (src) => {
    const login = localStorage.getItem("login");
    if (!login) return alert("Utilisateur non identifié.");

    const dataToSave = {
      titre: src?.titre ?? titre ?? "",
      indication: src?.indication ?? indication ?? "",
      resultat: src?.resultat ?? resultat ?? "",
      conclusion: src?.conclusion ?? conclusion ?? "",
    };

    if (![dataToSave.titre, dataToSave.indication, dataToSave.resultat, dataToSave.conclusion]
          .some(v => (v || "").trim().length > 0)) {
      alert("Renseignez au moins un champ avant d'ajouter aux rapports types.");
      return;
    }

    try {
      setSavingRT(true);
      const { data: newRT } = await api.post(
        `${process.env.REACT_APP_EUREKA_PACS_URL}/api/rapportTypes/user/${login}`,
        dataToSave,
        { headers: { ...buildHeaders(), "Content-Type": "application/json" } }
      );

      if (newRT) setExamensType(prev => [newRT, ...prev]);
      setPopupMessage("Modèle ajouté à vos rapports types.");
      setShowPopup(true);
    } catch (e) {
      console.error("Erreur ajout rapport type :", e);
      setPopupMessage("Échec de l'ajout au rapport type.");
      setShowPopup(true);
    } finally {
      setSavingRT(false);
    }
  };

  // -------------------- Speech-to-Text (Web Speech API) --------------------
  const SpeechRecognition =
    typeof window !== "undefined" &&
    (window.SpeechRecognition || window.webkitSpeechRecognition);

  const getFieldValue = useCallback((field) => {
    switch (field) {
      case "titre": return titre || "";
      case "indication": return indication || "";
      case "resultat": return resultat || "";
      case "conclusion": return conclusion || "";
      default: return "";
    }
  }, [titre, indication, resultat, conclusion]);

  const setFieldValue = useCallback((field, value) => {
    switch (field) {
      case "titre": setTitre(value); break;
      case "indication": setIndication(value); break;
      case "resultat": setResultat(value); break;
      case "conclusion": setConclusion(value); break;
      default: break;
    }
  }, []);


  useEffect(() => {
  if (!publicId) return;
  fetchExamen().then(() => {
    fetchRapports();
    fetchOrdonnances();
    fetchImagesExamen(); 
  });
  fetchExamensType();
}, [publicId]);


  const openSTT = useCallback((field) => {
    setActiveField(field);
    setSttError("");
    finalTextRef.current = getFieldValue(field);
    interimRef.current = "";
    setLiveText(finalTextRef.current);

    if (!SpeechRecognition) {
      setSttError("Reconnaissance vocale non supportée par ce navigateur.");
      setSttOpen(true);
      return;
    }

    try {
      const rec = new SpeechRecognition();
      recognitionRef.current = rec;
      rec.lang = "fr-FR";
      rec.interimResults = true;
      rec.continuous = true;

      rec.onresult = (event) => {
        let interim = "";
        for (let i = event.resultIndex; i < event.results.length; i++) {
          const res = event.results[i];
          if (res.isFinal) {
            finalTextRef.current = (finalTextRef.current + " " + res[0].transcript).trim();
          } else {
            interim += res[0].transcript;
          }
        }
        interimRef.current = interim;
        setLiveText((finalTextRef.current + " " + interimRef.current).trim());
      };

      rec.onerror = (e) => {
        console.error("STT error:", e);
        setSttError(e.error === "no-speech"
          ? "Aucun son détecté. Réessaie."
          : "Erreur de reconnaissance vocale.");
      };

      rec.onend = () => {
        // Si overlay encore ouvert et on n'a pas explicitement stoppé, on relance (meilleure robustesse)
        if (sttOpen && isListening) {
          try { rec.start(); } catch {}
        }
      };

      setSttOpen(true);
      setIsListening(true);
      rec.start();
    } catch (e) {
      console.error(e);
      setSttError("Impossible de démarrer la reconnaissance vocale.");
      setSttOpen(true);
      setIsListening(false);
    }
  }, [SpeechRecognition, getFieldValue, sttOpen, isListening]);

  const stopSTT = useCallback(() => {
    setIsListening(false);
    try { recognitionRef.current && recognitionRef.current.stop(); } catch {}
  }, []);

  const closeSTT = useCallback(() => {
    stopSTT();
    setSttOpen(false);
    setActiveField(null);
    setSttError("");
    interimRef.current = "";
  }, [stopSTT]);

  const insertSTT = useCallback(() => {
    // On insère uniquement le texte final (sans l'interim)
    const clean = (finalTextRef.current || "").replace(/\s+/g, " ").trim();
    if (activeField) setFieldValue(activeField, clean);
    closeSTT();
  }, [activeField, setFieldValue, closeSTT]);

  // ESC pour fermer/annuler
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape" && sttOpen) {
        closeSTT();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [sttOpen, closeSTT]);

  // -------------------- RENDER --------------------
  if (!examen) return <p>Chargement des détails de l'examen...</p>;

  return (
    <div className="container">
      {/* ======== COLONNE GAUCHE ======== */}
   <div className="box box-info">
        <div className="buttons">
          <button className="btn btn-hom" onClick={() => navigate("/accueil")}>
            <span role="img" aria-label="acceuil">🏠</span>Retour à l'accueil
          </button>

          <button className="btn btn-blue" onClick={fetchExamen}>
            <span role="img" aria-label="Actualiser">🔄</span>Actualiser
          </button>

          {(authService.isRadiologue()|| authService.isTechnicien()) && (
            <button
              className="btn btn-purple"
              onClick={() => openOHIFViewer(examen.dicom?.[0]?.study)}
            >
              <span role="img" aria-label="Visualiser">👁️</span> Visualiser les images
            </button>
          )}

          <button className="btn-validate" onClick={() => handleSave("TERMINE")}>
            <span role="img" aria-label="Valider">✅</span> Terminer l'examen
          </button>
        </div>

        <div className="section-dest">
          <h2>EXAMEN</h2>
          <div className="info-item"><strong>Numéro :</strong> {examen.id}</div>
          <div className="info-item"><strong>Libellé :</strong> {examen.nom}</div>
          <div className="info-item"><strong>Type :</strong> {examen.type}</div>
          <div className="info-item">
            <strong>Date :</strong>{" "}
            {examen.created_at ? new Date(examen.created_at).toLocaleDateString() : ""}
          </div>
          <div className="info-item">
            <strong>Statut :</strong>{" "}
            {examen.statut === "TERMINE"
              ? "Terminé"
              : examen.statut === "AVEC_CR"
              ? "Avec CR"
              : "Sans CR"}
          </div>
          <div className="info-item"><strong>Criticité :</strong> {examen.criticite}</div>
        </div>

        <div className="section-dest">
          <h2>PATIENT</h2>
          <div className="info-item"><strong>Nom :</strong> {examen.patient.personne?.nom}</div>
          <div className="info-item"><strong>Prénom :</strong> {examen.patient.personne?.prenom}</div>
          <div className="info-item">
            <strong>Âge :</strong> {calculerAge(examen.patient.personne?.date_naissance)} ans
          </div>
          <div className="info-item"><strong>Sexe :</strong> {examen.patient.personne?.sexe}</div>
        </div>

        <div className="section-dest">
          <h2>Radiologues</h2>
          <div className="info-item"><strong>Prescripteur :</strong> X</div>
          <div className="info-item"><strong>Destinataire :</strong> X</div>
        </div>

        <div className="section-dest">
          <h2>Autres</h2>
          <div className="info-item"><strong>Machine :</strong> Siemens Healthineers</div>
        </div>

        <div className="section-histo">
          <h2>Historique du Patient</h2>
          <div className="table-container">
            <table className="histo-table reports-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Libellé</th>
                  <th>Nature</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {examens.map((ex) => (
                  <tr key={ex.id}>
                    <td data-label="Date">
                      {ex.created_at ? new Date(ex.created_at).toLocaleDateString() : ""}
                    </td>
                    <td data-label="Type">{ex.type}</td>
                    <td data-label="Libellé">{ex.nom}</td>
                    <td data-label="Nature">
                      {ex.statut === "TERMINE" ? "Terminé" : ex.statut === "AVEC_CR" ? "Avec CR" : "Sans CR"}
                    </td>
                    <td data-label="Actions" className="actions">
                      <img src="/info.png" alt="info" className="icon profil" />
                    </td>
                  </tr>
                ))}
              </tbody>

            </table>
          </div>
        </div>

      </div>

      {/* ======== COLONNE DROITE (tableau de rapports) ======== */}
     <div className="box box-rapports">
  <div className="header">
    <h2 className="section-title">📑 Rapports</h2>
    <div className="header-actions">
      {/* Bouton ajouter bulletin */}
      <label htmlFor="ordonnance-upload" className="btn btn-purple">
        📑 Ajouter bulletin
      </label>
      <input
        type="file"
        id="ordonnance-upload"
        style={{ display: "none" }}
        accept="image/*,.pdf"
        onChange={handleUploadOrdonnance}
      />

      {/* Bouton ajouter image */}
       {authService.isRadiologue() && (
        <>
          <label htmlFor="imageExamen-upload" className="btn btn-purple">
            🖼️ Ajouter image
          </label>
          <input
            type="file"
            id="imageExamen-upload"
            style={{ display: "none" }}
            accept="image/*"
            onChange={handleUploadImageExamen}
          />
        </>
      )}


      {/* Bouton ajouter rapport */}
      {authService.isRadiologue() && (
        <button className="btn btn-green" onClick={openAddPopup}>
          + Ajouter un rapport
        </button>
      )}
    </div>
  </div>

  {/* Table des rapports (inchangée) */}
  <div className="table-container">
    <table className="histo-table reports-table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Titre</th>
          <th>Indication</th>
          <th>Conclusion</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {loadingRapports && (
          <tr>
            <td colSpan="5">Chargement des rapports…</td>
          </tr>
        )}
        {!loadingRapports && rapports.length === 0 && (
          <tr>
            <td colSpan="5">Aucun rapport</td>
          </tr>
        )}
        {!loadingRapports &&
          rapports.map((r) => (
            <tr key={r.id}>
              <td data-label="Date">{fmtDate(r.createdAt || r.created_at)}</td>
              <td data-label="Titre">{r.titre || "Sans titre"}</td>
              <td data-label="Indication">{htmlToPlainText(preview(r.indication, 40))}</td>
              <td data-label="Conclusion">{htmlToPlainText(preview(r.conclusion, 40))}</td>
              <td data-label="Action">
                <div className="buttons">
                  {authService.isRadiologue() && (
                    <button className="btn btn-blue" onClick={() => openEditPopup(r)}>
                      ✏️ Éditer
                    </button>
                  )}
                  <button
                    className="btn btn-blue"
                    onClick={() => navigate(`/rapport/${examen.publicId}`, { state: { rapport: r } })}
                  >
                    📄 Générer
                  </button>
                  {authService.isRadiologue() && (
                    <>
                      <button
                        className="btn btn-purple"
                        type="button"
                        onClick={() => handleAddToRapportTypes(r)}
                        disabled={savingRT}
                      >
                        ⭐ Favori
                      </button>
                      <button
                        className="btn btn-red"
                        type="button"
                        onClick={() => handleDeleteRapport(r.id)}
                      >
                        🗑️ Supprimer
                      </button>
                    </>
                  )}
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  </div>

  {/* Section ordonnances */}
{ordonnances.length > 0 && (
  <div className="ordonnances-section">
    <h2 className="section-title">📝 Les bulletins de radiographie</h2>
    <div className="ordonnances-list" style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
      {ordonnances.map((ord, idx) => (
        <div 
          key={idx} 
          className="ordonnance-item"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            border: "1px solid #ddd",
            padding: "10px",
            borderRadius: "6px"
          }}
        >
          {ord.presignedUrl?.endsWith(".pdf") ? (
            <a href={ord.presignedUrl} target="_blank" rel="noopener noreferrer">
              📄 Voir le PDF
            </a>
          ) : (
            <img
              src={ord.presignedUrl}
              alt={`Ordonnance ${idx + 1}`}
              style={{
                maxWidth: "200px",
                border: "1px solid #ccc",
                marginBottom: "10px",
                borderRadius: "4px",
              }}
              onClick={() => setSelectedOrdonnanceIndex(idx)}
            />
          )}

          <button
            className="btn btn-red"
            style={{ marginTop: "auto" }}
            onClick={() => handleDeleteFichier(ord.id, "ordonnance")}
          >
            🗑️ Supprimer
          </button>
        </div>
      ))}
    </div>
  </div>
)}



  {/* Section images examen */}
{imagesExamen.length > 0 && (
  <div className="images-examen-section">
    <h2 className="section-title">🖼️ Images de l'examen</h2>

    <div className="qr-actions">
      <button
        className="btn btn-blue"
        onClick={() =>
          navigate(`/rapport-qr/${examen.publicId}`, { state: { examen } })
        }
      >
        📲 Générer QR Code
      </button>
    </div>

    <div 
      className="images-list"
      style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}
    >
      {imagesExamen.map((img, idx) => (
        <div 
          key={idx} 
          className="image-item"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            border: "1px solid #ddd",
            padding: "10px",
            borderRadius: "6px"
          }}
        >
          <img
            src={img.presignedUrl}
            alt={`Image examen ${idx + 1}`}
            style={{
              maxWidth: "200px",
              marginBottom: "10px",
              border: "1px solid #ccc",
              cursor: "pointer",
              borderRadius: "4px",
            }}
            onClick={() => setSelectedImageIndex(idx)}
          />

          <button
            className="btn btn-red"
            style={{ marginTop: "auto" }}
            onClick={() => handleDeleteFichier(img.id, "imageExamen")}
          >
            🗑 Supprimer
          </button>
        </div>
      ))}
    </div>
  </div>
)}


</div>


      {/* ======== POPUP AJOUT / ÉDITION RAPPORT ======== */}
      {showAddPopup && (
        <div className="popup-overlay">
          <div className="popup-content popup-wide">
            <h3>{editingRapportId == null ? "Éditer le rapport" : "Éditer le rapport"}</h3>
               <button
                  className="btn btn-purple"
                  type="button"
                  onClick={() => setShowRTModal(true)}
                >
                  🧩 Utiliser un rapport type
                </button>
                     <label></label>
            {/* --- Champ Titre + mic --- */}
            <div className="form-row">
              <label>Titre</label>
              <div className="input-with-mic">
                <textarea
                  className="title-input"
                  value={titre}
                  onChange={(e) => setTitre(e.target.value)}
                  placeholder="Ex. IRM cérébrale — compte-rendu"
                />
                <button
                  type="button"
                  className="voice-btn"
                  title="Dicter le titre"
                  onClick={() => openSTT("titre")}
                >
                  <span className="emoji-mic" role="img" aria-label="micro">🎙️</span>
                </button>
              </div>
            </div>

            {/* --- Champ Indication + mic --- */}
            <div className="form-row">
              <label>Indication</label>
              <div className="input-with-mic">
<textarea
     className="indication-input"
     value={indication}
     onChange={(e) => setIndication(e.target.value)}
     placeholder="Motif clinique, antécédents, protocole…"
   />
                <button
                  type="button"
                  className="voice-btn"
                  title="Dicter l'indication"
                  onClick={() => openSTT("indication")}
                >
                  <span className="emoji-mic" role="img" aria-label="micro">🎙️</span>
                </button>
              </div>
            </div>

{/* --- Résultat --- */}
<div className="form-row">
  <label>Résultat</label>
  <div className="input-with-mic">
    <div className="field-box editor-resultat">
      <QuillRichText
        value={resultat}
        onChange={setResultat}
        placeholder="Décrire observations, mesures, localisations…"
      />
    </div>
    <button type="button" className="voice-btn" onClick={() => openSTT("resultat")}>🎙️</button>
  </div>
</div>

{/* --- Conclusion --- */}
<div className="form-row">
  <label>Conclusion</label>
  <div className="input-with-mic">
    <div className="field-box editor-conclusion">
      <QuillRichText
        value={conclusion}
        onChange={setConclusion}
        placeholder="Synthèse, diagnostic différentiel, recommandation…"
      />
    </div>
    <button type="button" className="voice-btn" onClick={() => openSTT("conclusion")}>🎙️</button>
  </div>
</div>


            <div className="actions">
              <div className="buttons">
                <button
                  className="btn btn-green"
                  onClick={handleSaveRapport}
                  disabled={isSaving}
                >
                  {isSaving ? "Sauvegarde..." : "💾 Sauvegarder"}
                </button>

             

                <button
                  className="btn btn-red"
                  onClick={() => setShowAddPopup(false)}
                  disabled={isSaving || savingRT}
                >
                  ❌ Annuler
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ======== POPUP LISTE DES RAPPORTS TYPES ======== */}
      {showRTModal && (
        <div className="popup-overlay">
          <div className="popup-content popup-wide">
            <div className="rt-modal-header">
              <h3>Rapports types</h3>
              <button className="btn btn-red btn-small" onClick={() => setShowRTModal(false)}>Fermer</button>
            </div>

            <div className="rt-search">
              <input
                type="text"
                placeholder="Rechercher dans titre / indication / résultat / conclusion / type…"
                value={rtSearch}
                onChange={(e) => setRtSearch(e.target.value)}
              />
            </div>

            <div className="table-container dark">
              <table className="rt-table">
  <thead>
    <tr>
      <th>Titre</th>
      <th>Indication</th>
      <th>Résultat</th>
      <th>Conclusion</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {examensType
      .filter((rt) => {
        const hay = [
  rt?.titre,
  rt?.indication,
  rt?.resultat,
  rt?.conclusion,
]
  .filter(Boolean)
  .map((val) => htmlToPlainText(val))   // 🔑 convertir en texte simple
  .join(" ")
  .toLowerCase();

        const terms = rtSearch.toLowerCase().split(/\s+/).filter(Boolean);

        // ✅ si pas de recherche → tout afficher
        if (terms.length === 0) return true;

        // ✅ sinon → garder la ligne si au moins 1 mot est trouvé
        return terms.every((term) => hay.includes(term));
      })
      .map((rt) => {
        const terms = rtSearch.toLowerCase().split(/\s+/).filter(Boolean);

        return (
          <tr key={rt.id}>
            <td>{highlightExcerpt(htmlToPlainText(rt.titre), terms)}</td>
            <td>{highlightExcerpt(htmlToPlainText(rt.indication), terms)}</td>
            <td>{highlightExcerpt(htmlToPlainText(rt.resultat), terms)}</td>
            <td>{highlightExcerpt(htmlToPlainText(rt.conclusion), terms)}</td>
            <td>
              <button
                className="btn btn-green btn-small"
                onClick={() => {
                  setTitre(rt.titre || "");
                  setIndication(rt.indication || "");
                  setResultat(rt.resultat || "");
                  setConclusion(rt.conclusion || "");
                  setShowRTModal(false);
                }}
              >
                ➕ Utiliser
              </button>
            </td>
          </tr>
        );
      })}

    {examensType.length === 0 && (
      <tr>
        <td colSpan="5">Aucun modèle trouvé</td>
      </tr>
    )}
  </tbody>
</table>

            </div>

          </div>
        </div>
      )}

      {/* Popup info */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <p>{popupMessage || "Opération effectuée."}</p>
            <button className="btn btn-blue" onClick={() => setShowPopup(false)}>Fermer</button>
          </div>
        </div>
      )}

      {/* ======== OVERLAY SPEECH-TO-TEXT ======== */}
      {sttOpen && (
        <div className="stt-overlay" role="dialog" aria-modal="true">
          <div className="stt-card">
            <div className="stt-visual" aria-hidden="true">
              <div className="stt-pulse stt-pulse-1" />
              <div className="stt-pulse stt-pulse-2" />
              <div className="stt-pulse stt-pulse-3" />
              <div className={`stt-mic ${isListening ? "listening" : ""}`}>
                {isListening
  ? <Mic size={36} color="#EAF2FF" strokeWidth={2.25} />
  : <MicOff size={36} color="#EAF2FF" strokeWidth={2.25} />
}
              </div>
            </div>

            <div className="stt-body">
              <div className="stt-title">
                {isListening ? "Parlez… (enregistrement en cours)" : "Enregistrement arrêté"}
              </div>
              {sttError && <div className="stt-error">{sttError}</div>}

              <div
                  className="stt-text"
                  aria-live="polite"
                  dangerouslySetInnerHTML={{ __html: liveText }}
                />



              <div className="stt-actions">
                {isListening ? (
                  <button className="btn btn-outline" onClick={stopSTT}>
                    <MicOff size={18} color="#EAF2FF" strokeWidth={2.25} />&nbsp;Arrêter
                  </button>
                ) : (
                  <>
                    <button className="btn btn-green" onClick={insertSTT}>
                      ✅ Arrêter & insérer
                    </button>
                    <button className="btn btn-ghost" onClick={closeSTT}>
                      ✖ Annuler
                    </button>
                  </>
                )}
              </div>
              {!SpeechRecognition && (
                <div className="stt-help">
                  Astuce : utilise Chrome/Edge sur desktop ou Android pour la dictée vocale.
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {selectedImage && (
  <div
    className="image-overlay"
    onClick={() => setSelectedImage(null)}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.8)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 2000,
    }}
  >
    <img
      src={selectedImage}
      alt="Aperçu ordonnance"
      style={{ maxHeight: "90%", maxWidth: "90%", borderRadius: "8px" }}
    />
  </div>
)}


{selectedOrdonnanceIndex !== null && (
  <div
    className="image-overlay"
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.9)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      zIndex: 3000,
      color: "#fff",
    }}
  >
    {/* Bouton fermer */}
    <button
      style={{
        position: "absolute",
        top: "20px",
        right: "30px",
        fontSize: "28px",
        color: "#fff",
        background: "transparent",
        border: "none",
        cursor: "pointer",
      }}
      onClick={() => {
        setSelectedOrdonnanceIndex(null);
        setRotation(0); // ✅ réinitialise la rotation
      }}
    >
      ✖
    </button>

    {/* Image affichée */}
    <img
      src={ordonnances[selectedOrdonnanceIndex].presignedUrl}
      alt={`Ordonnance ${selectedOrdonnanceIndex + 1}`}
      style={{
        maxHeight: "80%",
        maxWidth: "90%",
        borderRadius: "8px",
        boxShadow: "0 0 15px rgba(255,255,255,0.2)",
        transform: `rotate(${rotation}deg)`,
        transition: "transform 0.3s ease",
      }}
      onClick={(e) => e.stopPropagation()}
    />

    {/* Contrôles : précédent, rotation, suivant */}
    <div style={{ marginTop: "15px", display: "flex", gap: "20px" }}>
      <button
        onClick={() => {
          setSelectedOrdonnanceIndex(
            (selectedOrdonnanceIndex - 1 + ordonnances.length) % ordonnances.length
          );
          setRotation(0); // ✅ remet droit après navigation
        }}
        style={{ fontSize: "22px", cursor: "pointer" }}
      >
        ◀
      </button>

      <button
        onClick={() => setRotation((prev) => (prev + 90) % 360)}
        style={{ fontSize: "22px", cursor: "pointer" }}
      >
        🔄 Rotation
      </button>

      <button
        onClick={() => {
          setSelectedOrdonnanceIndex(
            (selectedOrdonnanceIndex + 1) % ordonnances.length
          );
          setRotation(0); // ✅ idem ici
        }}
        style={{ fontSize: "22px", cursor: "pointer" }}
      >
        ▶
      </button>
    </div>

    {/* Compteur */}
    <p style={{ marginTop: "10px" }}>
      {selectedOrdonnanceIndex + 1} / {ordonnances.length}
    </p>
  </div>
)}




{selectedImageIndex !== null && (
  <div
    className="image-overlay"
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.9)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      zIndex: 2000,
      color: "#fff"
    }}
  >
    <button
      style={{
        position: "absolute",
        top: "20px",
        right: "30px",
        fontSize: "28px",
        color: "#fff",
        background: "transparent",
        border: "none",
        cursor: "pointer"
      }}
      onClick={() => {
        setSelectedImageIndex(null);
        setRotation(0); // ✅ réinitialise la rotation à la fermeture
      }}
    >
      ✖
    </button>

    <img
      src={imagesExamen[selectedImageIndex].presignedUrl}
      alt={`Image examen ${selectedImageIndex + 1}`}
      style={{
        maxHeight: "80%",
        maxWidth: "90%",
        borderRadius: "8px",
        boxShadow: "0 0 15px rgba(255,255,255,0.2)",
        transform: `rotate(${rotation}deg)`,
        transition: "transform 0.3s ease"
      }}
    />

    <div style={{ marginTop: "15px", display: "flex", gap: "20px" }}>
      <button
        onClick={() => {
          setSelectedImageIndex(
            (selectedImageIndex - 1 + imagesExamen.length) % imagesExamen.length
          );
          setRotation(0); // ✅ remet l’image suivante droite
        }}
        style={{ fontSize: "22px", cursor: "pointer" }}
      >
        ◀
      </button>

      <button
        onClick={() => setRotation((prev) => (prev + 90) % 360)}
        style={{ fontSize: "22px", cursor: "pointer" }}
      >
        🔄 Rotation
      </button>

      <button
        onClick={() => setShowCropper(true)}
        style={{ fontSize: "22px", cursor: "pointer" }}
      >
        ✂️ Rogner
      </button>
      <button
        onClick={() => {
          setSelectedImageIndex((selectedImageIndex + 1) % imagesExamen.length);
          setRotation(0); // ✅ idem ici
        }}
        style={{ fontSize: "22px", cursor: "pointer" }}
      >
        ▶
      </button>
    </div>

    <p style={{ marginTop: "10px" }}>
      {selectedImageIndex + 1} / {imagesExamen.length}
    </p>
  </div>
)}


{showCropper && selectedImageIndex !== null && (
  <div
    className="cropper-overlay"
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.9)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 4000,
    }}
  >
    <div style={{ position: "relative", width: "80%", height: "70%" }}>
      <Cropper
        image={imagesExamen[selectedImageIndex].presignedUrl}
        crop={crop}
        zoom={zoom}
        aspect={4 / 3}
        onCropChange={setCrop}
        onZoomChange={setZoom}
        onCropComplete={(croppedArea, croppedAreaPixels) => {
          setCroppedAreaPixels(croppedAreaPixels);
        }}
      />
    </div>

    <div style={{ marginTop: "20px", display: "flex", gap: "20px" }}>
     <button
  className="btn btn-green"
  onClick={async () => {
    try {
      const { blob, url } = await getCroppedImg(
        imagesExamen[selectedImageIndex].presignedUrl,
        croppedAreaPixels
      );

      // ⚡ Option 1 : afficher dans l’UI
      console.log("✅ Image croppée URL:", url);

      // ⚡ Option 2 : uploader vers backend
      const formData = new FormData();
      formData.append("file", blob, blob.name);

      await api.post(
        `${process.env.REACT_APP_EUREKA_PACS_URL}/api/examen/${publicId}/upload?categorie=imageExamen`,
        formData,
        { headers: { ...buildHeaders(), "Content-Type": "multipart/form-data" } }
      );

      // Rafraîchir la liste
      await fetchImagesExamen();

      setPopupMessage("✅ Image croppée et sauvegardée avec succès !");
      setShowPopup(true);

      setShowCropper(false);
    } catch (err) {
      console.error("Erreur crop :", err);
      setPopupMessage("❌ Erreur lors du rognage de l’image.");
      setShowPopup(true);
    }
  }}
>
  ✅ Valider
</button>


      <button className="btn btn-red" onClick={() => setShowCropper(false)}>
        ❌ Annuler
      </button>
    </div>
  </div>
)}


    </div>
  );
};

export default DetailExam;
